import { createWizard } from "../wizards";

export type OptInMarketingFlowPages = "OptInLandingPage" | "OptInSuccessfulPage";

export const optInMarketingFlowWizard = createWizard<OptInMarketingFlowPages>("OptInMarketingFlowWizard", [
    "OptInLandingPage",
    "OptInSuccessfulPage",
]);
